import { Component, EventEmitter, forwardRef, Input, Output, Provider, Renderer2 } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

const CHECKBOX_VALUE_ACCESSOR: Provider = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => TfCheckboxComponent),
    multi: true,
};

@Component({
    selector: 'tf-checkbox',
    templateUrl: './tf-checkbox.component.html',
    styleUrls: ['./tf-checkbox.component.scss'],
    providers: [CHECKBOX_VALUE_ACCESSOR]
})
export class TfCheckboxComponent implements ControlValueAccessor {

    @Input() label: string | null = null;
    @Input() disabled: boolean = false;
    @Input() checked: boolean = false;
    @Input() name: string | null = null;
    @Input() value: unknown = null;
    @Input() id: string | null = null;
    @Input() partial: boolean = false;

    @Output() onClick: EventEmitter<unknown> = new EventEmitter();

    public onModelChange: (value: unknown) => void = (): void => {
    };
    public onTouch: () => void = (): void => {
    };

    model: boolean;

    constructor(
        private _renderer: Renderer2
    ) {
    }

    handleClick(event: Event) {
        event.preventDefault();
        event.stopPropagation();
        if (this.disabled) {
            return;
        }
        this.checked = !this.checked;
        this.updateModel(event);
    }

    isChecked(): boolean {
        return this.model;
    }

    updateModel(event: Event) {

        this.onClick.emit({
            originalEvent: event,
            checked: this.checked
        });

        this.onModelChange(this.checked);

    }

    onBlur(): void {
        this.onTouch();
    }

    getCheckmarkClass(): string {
        return this.partial ? 'checkmark-partial' : 'checkmark';
    }

    writeValue(value: boolean): void {
        if (value !== undefined) {
            this.model = value;
            this.checked = this.isChecked();
        }
    }

    registerOnChange(fn: () => void): void {
        this.onModelChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouch = fn;
    }

    setDisabledState(val: boolean): void {
        this.disabled = val;
    }

}
